<div class="component-header">
   @if (snapshots.length > 1) {
      <!-- Hamburger Icon to show/hide report history -->
      <span class="fa-solid fa-bars toolbar-icon" (click)="toggleRefreshHistoryPanel()" [title]="showRefreshHistoryPanel ? 'Hide Snapshot History' : 'Show Snapshot History'"></span>
   }
   <!-- Report Title -->
   <span class="report-title">{{ loading ? "Loading Report..." : theReport?.Name }}</span>

   <!-- Share Button -->
   @if (userCanEdit) {
      <div class="share-button">
         <span class="fa-solid fa-arrows-rotate toolbar-icon" (click)="refreshReport()"></span>
         @if (userHasOwnership) {
            <span class="fa-solid fa-share toolbar-icon" (click)="doResourcePermissionsDialog()"></span>
         }
      </div>   
   }
   @else {

   }
</div>

@if (loading) {
   <kendo-loader></kendo-loader>
}
@else if (loadingFailed) {
   <div class="loading-failed">
      <span class="fa-solid fa-exclamation-triangle"></span>
      <span>Failed to load report.</span>
   </div>
}
@else {
   @if (showResourcePermissions && userCanEdit) {
      <kendo-dialog
            title="Share Report"
            (close)="closeResourcePermissionsDialog('no')"
            [width]="650"
            [height]="400"
      >
         <mj-resource-permissions 
               [Provider]="Provider"
               [ResourceTypeID]="reportResourceTypeID"
               [ResourceRecordID]="theReport.ID"
               [ExcludedRoleNames]="['Developer','UI','Integration']"
               [ExcludedUserEmails]="['not.set@nowhere.com']"
               #resourcePermissions
         >
         </mj-resource-permissions>
         <kendo-dialog-actions>
            <button kendoButton (click)="closeResourcePermissionsDialog('yes')" themeColor="primary">
               Yes
            </button>
         <button kendoButton (click)="closeResourcePermissionsDialog('no')">
            No
         </button>
         </kendo-dialog-actions>
      </kendo-dialog>
   } 

   @if (userCanView) {
      <div class="report-container"> 
         <!-- Left Panel for Refresh History -->
         @if (snapshots.length > 1 && showRefreshHistoryPanel) {
            <div class="refresh-history">
               <h3>Snapshots</h3>
               <ul>
                  <li *ngFor="let snapshot of snapshots" 
                     [class.active]="snapshot.ID === activeSnapshot?.ID" 
                     (click)="selectSnapshot(snapshot)">
                     {{ snapshot.__mj_CreatedAt | date: 'medium' }}
                  </li>
               </ul>
            </div>   
         }
   
         <!-- Main Content Area -->
         <div class="report-content">
            <skip-dynamic-linear-report
               class="report"
               [ReportEntity]="theReport"
               [Provider]="Provider"
               [SkipData]="skipData"
               #reportComponent
            >
            </skip-dynamic-linear-report>
         </div>   
      </div>   
   }
   @else {
      <div class="no-permissions">
         <span class="fa-solid fa-lock"></span>
         <span>You do not have permission to view this report.</span>
      </div>
   }
}